import * as z from "zod/v4";
import {
  MarketingAgentAnalyticsInputSchema,
  MetricWithComparisonSchema,
} from "./common";

export const getMarketingAgentKeyMetrics = {
  name: "getMarketingAgentKeyMetrics" as const,
  input: MarketingAgentAnalyticsInputSchema,
  output: z.object({
    totalSentinelDecisions: MetricWithComparisonSchema,
    sentinelProceedRate: MetricWithComparisonSchema,
    sentinelSkipRate: MetricWithComparisonSchema,
    sentinelReevaluateRate: MetricWithComparisonSchema,
    bypassRate: MetricWithComparisonSchema,
    avgDecisionTimeSeconds: MetricWithComparisonSchema,
    totalVanguardDecisions: MetricWithComparisonSchema,
    totalWriterDecisions: MetricWithComparisonSchema,
  }),
};
